// Base configuration for axios
import axios from 'axios';

export const HTTP = axios.create({
    'baseURL': process.env.BASE_URL
})



// WEBPACK FOOTER //
// ./src/components/HTTP.js